<template>
  <v-container fluid id="visit_procedures">
    <v-row justify="end">
      <v-col cols="4" class="text-right">
        <v-btn color="primary" @click="copyPrevious" v-if="$can('do','POKO_Wizyty_Edycja_Przebiegu') && latest_conditions != null && latest_conditions.length > 0" class="mr-2">Skopiuj z poprzedniej wizyty</v-btn>
        <v-btn color="primary" @click="showAddIcd10=true" v-if="$can('do','POKO_Wizyty_Edycja_Przebiegu')">Dodaj</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
            :items="conditions"
            :headers="headers">
          <template v-slot:item="props">
            <tr>
              <td>{{props.item.icd10_code}}</td>
              <td>{{props.item.description}}</td>
              <td>{{props.item.type == 1 ? "Główne" : "Współistniejące"}}</td>
              <td>
                <v-icon small class="mr-2"  v-if="$can('do','POKO_Wizyty_Edycja_Przebiegu')" @click="removeCondition(props.item.id)" title="Usuń rozpoznanie">fa-trash-alt</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <ICD10Picker v-if="showAddIcd10" :visible="showAddIcd10" @close="showAddIcd10 = false" :visitid="visitid" @category_selected="categorySelected"></ICD10Picker>
  </v-container>
</template>

<script>
import ICD9PIcker from "@/components/visits/ICD9PIcker";
import {icdService, visitService} from "@/services";
import swal from "sweetalert";
import ICD10Picker from "@/components/visits/ICD10Picker";
export default {
  name: "VisitConditions",
  components: {ICD10Picker},
  props: ["visitid", "items", "latest_conditions"],
  data() {
    return {
      headers: [
        {text: 'Kod ICD10', sortable: false, align: 'left', value: 'icd10_code'},
        {text: 'Opis', sortable: false, align: 'left', value: 'description'},
        {text: 'Typ',sortable: false, align: 'left', value: 'type'},
        {text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
      showAddIcd10: false,
    }
  },
  mounted() {
  },
  computed: {
    conditions: {
      get: function() {
        return this.items ? this.items : []
      },
      set: function(val) {
        this.$emit('update:items',val)
      }
    }
  },
  methods: {
    removeCondition(id)
    {
      swal({
        title: "Czy na pewno?",
        text: "Czy na pewno chcesz usunąć to rozpoznanie?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          visitService.DeleteVisitCondition(id).then(()=> {
            let arr = [...this.conditions]

            arr.splice(this.items.findIndex(function(i){
              return i.id === id;
            }), 1);
            this.conditions = arr
          }).catch(()=>{
            this.showError('Błąd usuwania rozpoznania.')
          })
        }
      });

    },
    copyPrevious()
    {
      this.latest_conditions.forEach(elem => {
        visitService.AddVisitCondition({
          visitID: this.visitid,
          icd10_code: elem.icd10_code,
          description: elem.description,
          type: elem.type
        }).then((result) => {
          if(this.items == null) this.items = []
          let existingItem = this.items.find(x=>x.id == result.data.result.id)
          if(!existingItem)
          {
            let arr = [...this.conditions]
            arr.push(result.data.result)
            this.conditions = arr;
          }
        }).catch(()=> {
          this.showError('Błąd dodawania rozpoznania.')
        })
      })
    },
    categorySelected(value){
      visitService.AddVisitCondition({
        visitID: this.visitid,
        icd10_code: value.value.kod,
        description: value.value.opis_icd,
        type: value.concurrent ? 2 : 1
      }).then((result) => {
        if(this.items == null) this.items = []
        let existingItem = this.items.find(x=>x.id == result.data.result.id)
        if(!existingItem)
        {
          let arr = [...this.conditions]
          arr.push(result.data.result)
          this.conditions = arr;
        }
      }).catch(()=> {
        this.showError('Błąd dodawania rozpoznania.')
      })
      this.showAddIcd10 = false
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      })
    }
  }
}
</script>

<style scoped>

</style>